import { GroupMemberType } from './GroupMemberType';
import {Status} from './Status';

export class Recipient {
    id: string;
    sent: string;
    recipient_type: string;
    recipient_id: number | string;
    provider_reference: string;
    response_required: boolean;
    response_received: boolean;
    decline_reason_id: number;
    decline_reason: string;
    super_group_id: number;
    super_group: string;
    group_id: number;
    group: string;
    contact_id: number;
    individual_id: number;
    individual: string;
    external_id: string;
    device_id: number;
    channel_name: string;
    device_name: string;
    address: string;
    address_type: string;
    escalate_from_id: string;
    name?: string;
    escalate_from: string;
    statuses: Status[];
    ack_required?: boolean;
    group_ack_required?: boolean;
    type?: GroupMemberType;

    // UI Only
    recipient_email?: string;
    loading?: boolean;

    constructor(recipient_type?: string, recipient_id?: any, response_required?: any, name?: string) {
        this.recipient_type = recipient_type;
        this.recipient_id = recipient_id;
        this.response_required = response_required;
        this.name = name;
    }
}

export type Recipients = Array<Recipient>;

